export default "__VITE_ASSET__DgjHpacp__"